angular.module('app.core').factory('usuarioFactory', ['$http', function ($http) {

    var _apiName = 'SysUsuario';
    var _areaID = 0;

    var _setParams = function (areaID) {
        _areaID = areaID;
    };

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "AreaID", "value": _areaID });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            options.error(response.data);
        });
    };

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _findUserLoggedRecord = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindUserLoggedRecord');
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Update';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _listAll = function () {
        var dto = {};
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAll', dto);
    };

    var _listUsuarioPerfil = function (UserID) {
        var dto = {};
        dto.id = UserID;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListUsuarioPerfil', dto);
    };

    var _saveUsuarioPerfil = function (UserID, perfis) {
        var dto = {};
        dto.UserID = UserID;
        dto.Perfis = perfis;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SaveUsuarioPerfil', dto);
    };

    var _listUsuarioGrupo = function (UserID) {
        var dto = {};
        dto.id = UserID;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListUsuarioGrupo', dto);
    };

    var _saveUsuarioGrupo = function (UserID, grupos) {
        var dto = {};
        dto.UserID = UserID;
        dto.Grupos = grupos;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SaveUsuarioGrupo', dto);
    };

    var _listAllUsersExcept = function (UserID) {
        var dto = {};
        dto.id = UserID;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllUsersExcept', dto);
    };

    var _listAllBMPUsersExcept = function (UserID) {
        var dto = {};
        dto.id = UserID;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllBMPUsersExcept', dto);
    };

    var _listAllFuncionario = function () {
        var dto = {};
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllFuncionario', dto);
    };

    var _listAllFuncionarioMoneyPlus = function () {
        var dto = {};
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllFuncionarioMoneyPlus', dto);
    };

    var _listAllUsuarioEmpresaDisponivel = function (options, id) {
        var dto = { id: id };
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAllFuncionarioMoneyPlusDisponivel', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            options.error(response.data);
        });
    };

    var _loginAs = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/LoginAs', dto);
    };

    var _usuarioTemAcessoEmpresa = function (id, EPCodigo) {
        var dto = {
            id: id,
            EPCodigo: EPCodigo
        };
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/UsuarioTemAcessoEmpresa', dto);
    }

    var _buscaDadosUsuario = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BuscaDadosUsuario', dto);
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.setParams = _setParams;
    factory.findRecord = _findRecord;
    factory.findUserLoggedRecord = _findUserLoggedRecord;
    factory.list = _list;
    factory.listAll = _listAll;
    factory.save = _save;
    factory.delete = _delete;
    factory.listUsuarioPerfil = _listUsuarioPerfil;
    factory.saveUsuarioPerfil = _saveUsuarioPerfil;
    factory.listUsuarioGrupo = _listUsuarioGrupo;
    factory.saveUsuarioGrupo = _saveUsuarioGrupo;
    factory.listAllUsersExcept = _listAllUsersExcept;
    factory.listAllBMPUsersExcept = _listAllBMPUsersExcept;
    factory.listAllFuncionario = _listAllFuncionario;
    factory.listAllFuncionarioMoneyPlus = _listAllFuncionarioMoneyPlus;
    factory.listAllUsuarioEmpresaDisponivel = _listAllUsuarioEmpresaDisponivel;
    factory.loginAs = _loginAs;
    factory.buscaDadosUsuario = _buscaDadosUsuario;
    factory.usuarioTemAcessoEmpresa = _usuarioTemAcessoEmpresa;

    return factory;

}]);
